import { ChoiceButtonInput } from '@app/app/_components/Input/ChoiceButtonInput';
import { PaymentMethod } from '@app/domain/model/checkout/PaymentMethod';

interface Props {
    paymentMethods: PaymentMethod[];
}

export function PaymentStep({ paymentMethods }: Props) {
    return (
        <ChoiceButtonInput
            name="paymentMethod"
            inputContainerClassName="self-center"
            options={[
                ...paymentMethods.map(paymentMethod => ({
                    value: paymentMethod.type,
                    label: (
                        <div>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img className="h-7" src={paymentMethod.logoUrl} alt={paymentMethod.name} />
                        </div>
                    ),
                })),
            ]}
        />
    );
}
